import { alpha } from '@mui/material/styles';
const toolbarButtonStyles = _ref => {
  let {
    palette,
    spacing
  } = _ref;
  return {
    color: palette.text.secondary,
    minWidth: spacing(5),
    height: spacing(5),
    padding: 'unset',
    borderRadius: '50%',
    span: {
      margin: 'unset'
    },
    svg: {
      fontSize: '22px !important'
    },
    ':hover': {
      backgroundColor: alpha(palette === null || palette === void 0 ? void 0 : palette.text.secondary, palette.action.hoverOpacity)
    }
  };
};
export default toolbarButtonStyles;